import React from "react";
import { IBannerData } from "../../exports/interfaces";

const MemberBanner = (props: { becomeMememberBannerData: IBannerData[] }) => {
  return (
    <section className="page-header" style={{ marginTop: "71px" }}>
      <div
        className="page-header-bg"
        style={{
          backgroundImage:
            props?.becomeMememberBannerData[0]?.image[0]?.media?.url &&
            `url(${process.env.REACT_APP_cmsUrl}${props?.becomeMememberBannerData[0]?.image[0]?.media?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
        }}
      ></div>
      <div className="container">
        <div className="page-header__inner">
          <h2>{props?.becomeMememberBannerData[0]?.title}</h2>
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span>/</span>
            </li>
            <li className="active">
              {props?.becomeMememberBannerData[0]?.title}
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MemberBanner;
